// ═══════════════════════════════════════════════════════════════════
// absencesPlanning — logique PURE (v239) : fait lire au planning les arrêts
// maladie déclarés dans RH > Arrêts maladie (`arretsMaladie7`).
//
// Constat du 11/10/2026 : un arrêt déclaré dans RH n'apparaissait pas au
// planning, qui ne lit que `leave` (congés et absences). La salariée restait
// donc « affectable » alors qu'elle est absente.
//
// Principe : on ne copie rien, on ne migre rien. On produit, à l'affichage,
// des absences approuvées de type « maladie » à partir des arrêts, que le
// planning traite comme n'importe quelle absence (cellule bloquée, pas
// d'affectation). Les absences réelles passent EN PREMIER : sur un même jour,
// la première absence trouvée l'emporte (jamais de double décompte d'heures).
// Les entrées produites portent `arretRH: true` et un id `arret-…` : elles ne
// sont jamais écrites en base.
// ═══════════════════════════════════════════════════════════════════

const SANS_FIN = '9999-12-31';   // arrêt en cours sans date de fin : absent tant qu'une fin n'est pas saisie

/** Date « AAAA-MM-JJ » valide ? */
function jourValide(v) {
  return typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
}

/**
 * Absences effectives pour le planning = absences réelles + arrêts maladie. PURE.
 *  - arrêt sans salarié ou sans début valide : ignoré ;
 *  - fin renseignée mais avant le début (faute de frappe) : ignoré ;
 *  - sans fin : absent jusqu'à ce qu'une fin soit saisie — sauf statut « clôturé »
 *    (sans date de fin, on ne sait pas jusqu'où : on ne bloque rien) ;
 *  - type « at » (accident du travail) conservé, « maladie » et « mp » → maladie.
 * Ne modifie aucun des deux tableaux reçus.
 */
export function absencesPourPlanning(leave, arretsMaladie) {
  const reelles = Array.isArray(leave) ? leave : [];
  const arrets = Array.isArray(arretsMaladie) ? arretsMaladie : [];
  const virtuelles = [];
  for (const a of arrets) {
    if (!a || !a.sid || !jourValide(a.sd)) continue;
    let fin;
    if (jourValide(a.ed)) {
      if (a.ed < a.sd) continue;
      fin = a.ed;
    } else {
      if (a.statut === 'cloture') continue;
      fin = SANS_FIN;
    }
    virtuelles.push({
      id: `arret-${a.id || `${a.sid}-${a.sd}`}`,
      sid: a.sid,
      sd: a.sd,
      ed: fin,
      type: 'maladie',
      malType: a.type === 'at' ? 'at' : 'maladie',
      st: 'approved',
      arretRH: true,
      finNonRenseignee: fin === SANS_FIN,
    });
  }
  return virtuelles.length ? [...reelles, ...virtuelles] : reelles;
}
